import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import { CustomTextArea } from 'src/consumer/components/helperComponents'

export default function NextVisitSlotSelectionSkipConfirmaion({
  submitForm,
  isSaving,
  closeModal,
  reportReason,
  setReportReason,
  promptToOpenHoldSlotModal,
  onOpenHoldSlotModal,
  leaveRoom,
  isMarkingAsCompleted,
  skipLeaveRoomInDialog = false, // New prop: when true, parent handles leaveRoom via promise
}) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const showLoading = isSubmitting || isSaving
  return (
    <>
      <DialogTitle sx={{ pb: 2 }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          You&apos;ve Chosen To Skip Setting Next Visit.
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        {/* <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          We understand that scheduling the next visit might not always be possible right away. 
          Could you please let us know why you&apos;re skipping this step? This helps us improve our service.
        </Typography> */}
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Please Note Down The Reason For Doing So.
        </Typography>

        <CustomTextArea
          value={reportReason}
          onChange={(e) => setReportReason(e.target.value)}
          placeholder="Please share your reason for skipping (e.g., need to check availability, patient needs time to decide, etc.)"
          minRows={3}
        />
      </DialogContent>

      {promptToOpenHoldSlotModal && (
        <DialogContent sx={{ pt: 0, pb: 2 }}>
          <Box
            sx={{
              p: 2,
              bgcolor: 'primary.50',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'primary.200',
            }}
          >
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Or:
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              You can hold a slot for a follow-up visit instead.
            </Typography>
            <Button
              variant="outlined"
              onClick={onOpenHoldSlotModal}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              Hold Slot for Follow-Up Visit
            </Button>
          </Box>
        </DialogContent>
      )}

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          color="inherit"
          onClick={() => closeModal()}
          disabled={showLoading}
          sx={{ textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!reportReason?.trim() || showLoading}
          onClick={async () => {
            setIsSubmitting(true)
            // If leaveRoom is provided, we're being called during session exit flow
            // skipLeaveRoomInDialog = true means parent will handle leaveRoom via promise pattern
            if (leaveRoom && promptToOpenHoldSlotModal && !skipLeaveRoomInDialog) {
              await leaveRoom(isMarkingAsCompleted)
            }
            await submitForm()
            setIsSubmitting(false)
          }}
          sx={{
            textTransform: 'none',
            minWidth: 120,
            position: 'relative',
          }}
        >
          {showLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Processing...
            </>
          ) : (
            'Continue Without Setting Visit'
          )}
        </Button>
      </DialogActions>
    </>
  )
}
